export function toArray(nodes) {
	return Array.prototype.slice.call(nodes);
}

export function get(selector, context = document) {
	return context ? context.querySelector(selector) : [];
}

export function getAll(selector, context = document) {
	return context ? toArray(context.querySelectorAll(selector)) : [];
}

export function hasClass(el, name) {
	return el.classList.contains(name);
}

export function addClass(el, name) {
	return el.classList.add(name);
}

export function removeClass(el, name) {
	return el.classList.remove(name);
}

export function toggleClass(el, name, force) {
	const shouldAdd = typeof force === 'undefined' ? !hasClass(el, name) : force;

	return shouldAdd ? addClass(el, name) : removeClass(el, name);
}

export function createHtmlFragment(htmlString) {
	return document.createRange().createContextualFragment(htmlString.trim());
}

export function hasAttribute(el, name) {
	return el.hasAttribute(name);
}

export function removeAttribute(el, name) {
	el.removeAttribute(name);
}

export function addAttribute(el, name, value = true) {
	if (typeof name === 'object') {
		return Object.keys(name).forEach((key) => addAttribute(el, key, name[key]));
	}

	if (value == null) {
		el.removeAttribute(name);
	} else {
		el.setAttribute(name, value);
	}

	return el;
}

export function toggleAttribute(el, name, value = true, force) {
	const shouldAdd = typeof force === 'undefined' ? !hasAttribute(el, name) : force;

	return shouldAdd ? addAttribute(el, name, value) : removeAttribute(el, name);
}

export function getAttribute(el, attribute) {
	return el.getAttribute(attribute);
}

export function setProperty(el, name, value = '') {
	if (typeof name === 'object') {
		return Object.keys(name).forEach((key) => setProperty(el, key, name[key]));
	}

	// eslint-disable-next-line no-param-reassign
	el[name] = value;
	return el;
}

export function empty(el) {
	return setProperty(el, 'innerHTML');
}

export function forceRedraw(el) {
	el.offsetHeight; // eslint-disable-line
}

export function isInViewport (el) {
	const rect = el.getBoundingClientRect();
	const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
	const windowWidth = (window.innerWidth || document.documentElement.clientWidth);
	const vertInView = (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0);
	const horInView = (rect.left <= windowWidth) && ((rect.left + rect.width) >= 0);

  return (vertInView && horInView);
}
